"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IenvType = exports.UserTypeEnum = exports.EUserFromType = exports.ENOVELTOKENTYPE = exports.EIDType = exports.AmsRewardVideoStatus = void 0;
var AmsRewardVideoStatus;
(function (AmsRewardVideoStatus) {
    AmsRewardVideoStatus["OnADLoad"] = "onADLoad";
    AmsRewardVideoStatus["OnVideoCached"] = "onVideoCached";
    AmsRewardVideoStatus["OnADShow"] = "onADShow";
    AmsRewardVideoStatus["OnADExpose"] = "onADExpose";
    AmsRewardVideoStatus["OnReward"] = "onReward";
    AmsRewardVideoStatus["OnVideoComplete"] = "onVideoComplete";
    AmsRewardVideoStatus["OnADClose"] = "onADClose";
    AmsRewardVideoStatus["OnError"] = "onError";
    AmsRewardVideoStatus["OnLoadAdFail"] = "onLoadAdFail";
    AmsRewardVideoStatus["onADClick"] = "onADClick";
})(AmsRewardVideoStatus = exports.AmsRewardVideoStatus || (exports.AmsRewardVideoStatus = {}));
var EIDType;
(function (EIDType) {
    EIDType[EIDType["E_NATIVE_UNKNOWN_TYPE"] = -1] = "E_NATIVE_UNKNOWN_TYPE";
    EIDType[EIDType["E_NATIVE_GUID_TYPE"] = 0] = "E_NATIVE_GUID_TYPE";
    EIDType[EIDType["E_NATIVE_SID_TYPE"] = 1] = "E_NATIVE_SID_TYPE";
    EIDType[EIDType["E_NATIVE_QQ_TYPE"] = 2] = "E_NATIVE_QQ_TYPE";
    EIDType[EIDType["E_NATIVE_WEIXIN_TYPE"] = 3] = "E_NATIVE_WEIXIN_TYPE";
    EIDType[EIDType["E_NATIVE_QBID_TYPE"] = 4] = "E_NATIVE_QBID_TYPE";
    EIDType[EIDType["E_NATIVE_GUESTID_TYPE"] = 5] = "E_NATIVE_GUESTID_TYPE";
    EIDType[EIDType["E_NATIVE_QQ_OPEN_TYPE"] = 6] = "E_NATIVE_QQ_OPEN_TYPE";
    EIDType[EIDType["E_NATIVE_PHONE_TYPE"] = 7] = "E_NATIVE_PHONE_TYPE";
})(EIDType = exports.EIDType || (exports.EIDType = {}));
var ENOVELTOKENTYPE;
(function (ENOVELTOKENTYPE) {
    ENOVELTOKENTYPE[ENOVELTOKENTYPE["E_NOVEL_TOKEN_UNKNOWN"] = -1] = "E_NOVEL_TOKEN_UNKNOWN";
    ENOVELTOKENTYPE[ENOVELTOKENTYPE["E_NOVEL_TOKEN_SID"] = 0] = "E_NOVEL_TOKEN_SID";
    ENOVELTOKENTYPE[ENOVELTOKENTYPE["E_NOVEL_TOKEN_SKEY"] = 1] = "E_NOVEL_TOKEN_SKEY";
    ENOVELTOKENTYPE[ENOVELTOKENTYPE["E_NOVEL_TOKEN_A2"] = 2] = "E_NOVEL_TOKEN_A2";
    ENOVELTOKENTYPE[ENOVELTOKENTYPE["E_NOVEL_TOKEN_ACCESS"] = 3] = "E_NOVEL_TOKEN_ACCESS";
    ENOVELTOKENTYPE[ENOVELTOKENTYPE["E_NOVEL_TOKEN_LSKEY"] = 4] = "E_NOVEL_TOKEN_LSKEY";
    ENOVELTOKENTYPE[ENOVELTOKENTYPE["E_NOVEL_TOKEN_QQ_ACCESS"] = 5] = "E_NOVEL_TOKEN_QQ_ACCESS";
    ENOVELTOKENTYPE[ENOVELTOKENTYPE["E_NOVEL_TOKEN_PHONE_ACCESS"] = 6] = "E_NOVEL_TOKEN_PHONE_ACCESS";
})(ENOVELTOKENTYPE = exports.ENOVELTOKENTYPE || (exports.ENOVELTOKENTYPE = {}));
var EUserFromType;
(function (EUserFromType) {
    EUserFromType[EUserFromType["E_USERFROME_NATIVE"] = 0] = "E_USERFROME_NATIVE";
    EUserFromType[EUserFromType["E_USERFROME_WEB"] = 1] = "E_USERFROME_WEB";
    EUserFromType[EUserFromType["E_USERFROME_WX_QUANAPP"] = 2] = "E_USERFROME_WX_QUANAPP";
    EUserFromType[EUserFromType["E_USERFROME_WX_WENXUE"] = 3] = "E_USERFROME_WX_WENXUE";
})(EUserFromType = exports.EUserFromType || (exports.EUserFromType = {}));
var UserTypeEnum;
(function (UserTypeEnum) {
    UserTypeEnum[UserTypeEnum["QQ"] = 1] = "QQ";
    UserTypeEnum[UserTypeEnum["WECHAT"] = 2] = "WECHAT";
    UserTypeEnum[UserTypeEnum["QQCONNECT"] = 4] = "QQCONNECT";
    UserTypeEnum[UserTypeEnum["PHONE"] = 6] = "PHONE";
    UserTypeEnum[UserTypeEnum["GUEST"] = -1] = "GUEST";
})(UserTypeEnum = exports.UserTypeEnum || (exports.UserTypeEnum = {}));
var IenvType;
(function (IenvType) {
    IenvType["prod"] = "https://kde.qq.com/getAds";
    IenvType["gray"] = "https://kde.qq.com/getGrayAds";
    IenvType["test"] = "https://testreport.nfa.qq.com/getAds";
})(IenvType = exports.IenvType || (exports.IenvType = {}));
//# sourceMappingURL=index.js.map